import { render } from "./Metrics.vue?vue&type=template&id=c973df46&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"

import "./Metrics.vue?vue&type=style&index=0&id=c973df46&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c973df46"]])

export default __exports__